import {
  Panel,
  PanelSection,
  EmptyState,
  EmptyStateGraphic,
  EmptyStateTitle,
  EmptyStateDescription,
  Spinner,
  Text,
} from '@customerio/pluma-components/react';

export function VerificationStatusRunning() {
  return (
    <Panel>
      <PanelSection display="flex" justifyContent="center" alignItems="center" p="400">
        <EmptyState>
          <EmptyStateGraphic>
            <Spinner color="information" />
          </EmptyStateGraphic>
          <EmptyStateTitle>Verification in progress</EmptyStateTitle>
          <EmptyStateDescription>
            We're analyzing your account and website. This may take a few minutes.{' '}
            <Text as="span" weight="semibold">
              Keep this page open.
            </Text>
          </EmptyStateDescription>
        </EmptyState>
      </PanelSection>
    </Panel>
  );
}
